<div class="col-md-12">
<h2 class="txt txt--section pt-5">
  3. Información adicional
</h2>
<p class="txt txt--paragraph" [ngClass]="{
  'mb-5': validityTypes.length === 0
}">Ingresa la información necesaria para la aprobación.</p>
<form class="row" [formGroup]="additionalInformationForm">
  <!-- begin detail  form  only mel definitiva  temporal -->
  <div class="col-12" *ngIf="validityTypes.length > 0">
    <div class="row">
      <div class="col-12 col-md-6 col-xl-4 mr-xl-5 ">
        <div class="form form--required mb-4">
          <label for="" class="label">
            Vigencia de la licencia<app-tooltip text="Tipo de vigencia de la Licencia ."></app-tooltip>
          </label>
          <div class="form__radio" *ngFor="let item of validityTypes">
            <input class="temporal" formControlName="validity" type="radio" [id]="item.id" [value]="item.id">
            <label [for]="item.id">
              <div class="fakebox"></div>
              {{item.name}}
            </label>
          </div>
          <div class="form form--required mb-5 js-temporary" *ngIf="shouldShowDaysTemporaryDaysSelected">
            <label for="" class="label" style="height: 17px;">
            </label>
            <app-input [maxDigits]="3" [controlForm]="validityTemporaryDaysControl" inputType="number" sufix="Días"></app-input>
            <!-- <span
            class="days-sufix"
            [style.margin-left]="'calc((9.7px * (1 + ' + daysTextLength + ')) + 15px)'"
            >Dias</span>
            <input type="number" min="0" formControlName="validityTemporaryDays" autocomplete="off">
            <h6 class="form__info">*Formato solo numeros.</h6> -->
          </div>
        </div>
      </div>
      <ng-container *ngIf="shouldShowDaysTemporaryDaysSelected">
        <div class="col-12 col-md-6 col-xl-4 containerInfoValidityComment">
          <div class="form js-temporary">
            <app-text-area
            [controlForm]="comentaryTemporaryDays"
            [title]="'Por qué es una licencia temporal'"
            [placeholder]="'Comentario'"
            [maxlength]="300">
            </app-text-area>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- end  detail  form  only mel definitiva  temporal -->
  <!-- begin detail licence   -->
  <div class="col-12 col-md-6 col-xl-4 mr-xl-5">
    <div class="form form--required">
      <label for="" class="label">
        Selecciona la(s) licencia(s) municipal(es) registradas(s) por el solicitante<app-tooltip text="Selección de Licencia Municipal."></app-tooltip>
      </label>
      <div class="d-flex " *ngIf="municipalLicensesControlCreated">
        <div class="col-5">
          <div class="form__check" *ngFor="let item of parseLicenseMunicipalTypeA; let index = index ">
            <input class="js-disabled" [formControl]="municipalLicensesControls[index]" type="checkbox"
              [value]="item.id" [id]="item.id + item.name">
            <label [for]="item.id + item.name">
              <div class="fakebox fakebox--grey"></div>
              {{item.name}}
            </label>
          </div>
        </div>
        <div class="col-5">
          <div class="form__check" *ngFor="let  item of  parseLicenseMunicipalTypeBtoF; let index = index">
            <input type="checkbox" [formControl]="municipalLicensesControls[index + parseLicenseMunicipalTypeA.length]"
              [value]="item.id" [id]="item.id + item.name">
            <label [for]="item.id + item.name">
              <div class="fakebox fakebox--grey"></div>
              {{item.name}}
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 col-xl-4">
    <div class="form">

      <app-text-area
      [controlForm]="restrictionDriverNote"
      [title]="'Ingresa las restricciones para el conductor. (Opcional)'"
      [placeholder]="'Comentario'"
      [maxlength]="300"></app-text-area>
    </div>
  </div>

</form>
</div>
